Object.defineProperty(String.prototype, "getInt", {
    value: function (queryParam) {
        var found = new RegExp(queryParam + "=(\\d+)", "i").exec(this);

        return found ? parseInt(found[1], 10) || 0 : 0;
    }
});